import PropTypes from 'prop-types'

const StatusMessage = ({ text, success, show }) => {

  return (
    <If condition={show}>
      <div className={`status-message ${!success ? 'error ' : ''}p-3`}>
        <p>{text}</p>
      </div>
    </If>
  )
}

export default StatusMessage

StatusMessage.propTypes = {
  show: PropTypes.bool.isRequired,
  success: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
}
